<script setup lang="ts">
  import VisitorForm from '@/shared/components/rebranding/VisitorForm/VisitorForm.vue'
  import type { VisitorType } from '@/shared/types/store.types'

  interface Props {
    visitor: VisitorType
    isHolder: boolean
    isEdit: boolean
    isLoading: boolean
    emailIsValid: boolean
    editVisitorId: number | null | undefined
  }

  defineProps<Props>()

  defineEmits<{
    (e: 'save', visitor: VisitorType): void
    (e: 'delete', visitor: VisitorType): void
    (e: 'set-email-is-valid'): void
    (e: 'open-remove-window-event', visitor: VisitorType): void
    (e: 'close-remove-window-event', visitor: VisitorType): void
  }>()
</script>

<template>
  <VisitorForm
    :key="editVisitorId ?? undefined"
    :visitor="visitor"
    :is-holder="isHolder"
    :is-edit="isEdit"
    :is-loading="isLoading"
    :email-is-valid="emailIsValid"
    @save="$emit('save', $event)"
    @delete="$emit('delete', $event)"
    @set-email-is-valid="$emit('set-email-is-valid')"
    @open-remove-window-event="$emit('open-remove-window-event', $event)"
    @close-remove-window-event="$emit('close-remove-window-event', $event)"
  />
</template>
